import { useEffect, useMemo } from 'react';
import { resolveUserThumbnailSrc } from '../../utils/imageUtils';

/** Resolved display URL for an API user thumbnail, or null when unset. */
export function useUserThumbnailSrc(
  thumbnail: Blob | string | null | undefined,
): string | null {
  const { src, revokeUrl } = useMemo(
    () => resolveUserThumbnailSrc(thumbnail),
    [thumbnail],
  );

  useEffect(() => {
    if (revokeUrl == null) {
      return;
    }
    return () => {
      URL.revokeObjectURL(revokeUrl);
    };
  }, [revokeUrl]);

  return src;
}
